export const cartActionTypes = {
  // PRODUCT
  ADD_ITEM: 'ADD_ITEM',
  REMOVE_ITEM: 'REMOVE_ITEM',
  REMOVE_ALL_ITEMS: 'REMOVE_ALL_ITEMS',
};
